import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { agentSliceAction } from "../../../store/agentSlice"
import { getMisscalltimer } from "../../../utils/awsAPI"
import { millisecondsToHMS } from "../../../utils/utils"
import clockAlarm from "./../../../assets/images/clock-alarm.png";
import MissedCallPopup from "./MissedCallPopup"

const CallStatus = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const contactObj = useSelector((state: any) => { return state.contactSlice.contactObj })
    const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj })
    const isACW = useSelector((state: any) => { return state.agentSlice.isACW })
    const contactAttributes = useSelector((state: any) => { return state.contactAttributeSlice.contactAttributes })[0]
    const [agentCurrentState, setAgentCurrentState] = useState<any>("");
    const [stateDuration, setStateDuration] = React.useState("00:00:00")
    const [monitoringCallStatus, setMonitoringCallStatus] = React.useState<any>("")
    const [isCallback, setIsCallback] = useState<any>(false)
    const [callbackStatus, setCallbackStatus] = useState<any>("")
    const [minutes, setMinutes] = useState<any>(0)
    // let minutes: any;

    const [accountName, setAccountName] = useState("")
    const [alertShowed, setAlertShowed] = useState<any>(false)
    
    useEffect(() => {
    
        if (agentObj) {
            setAgentCurrentState(agentObj.getState().name)
            agentObj?.onRefresh(() => {
                setAgentCurrentState(agentObj.getState().name)
                if (agentObj?.getContacts().length === 0) {
                    setCallbackStatus("")
                }
            })
        }
        let interval: any;      

        if (contactObj) {
            
            try {
                setAccountName(contactObj?.getAttributes().AccountName?.value || "")
                let snapshotData = contactObj?.toSnapshot()
                let monitoringConnectionList = snapshotData?.contactData?.connections.filter((connection: any) => (connection.type === "monitoring" && (connection?.state?.type !== 'disconnected' && connection?.state?.type !== 'ended')))[0]
                setMonitoringCallStatus(monitoringConnectionList?.state?.type)
                setCallbackStatus(contactObj?.getState().type)
                if (contactObj?.getType() === 'queue_callback') {
                    setIsCallback(true)
                }


                contactObj?.onRefresh(() => {
                    let snapshotData = contactObj?.toSnapshot()
                    let monitoringConnectionList = snapshotData?.contactData?.connections.filter((connection: any) => (connection.type === "monitoring" && (connection?.state?.type !== 'disconnected' && connection?.state?.type !== 'ended')))[0]
                    setMonitoringCallStatus(monitoringConnectionList?.state?.type)
                    setCallbackStatus(contactObj?.getState().type)
                    if (contactObj?.getType() === 'queue_callback') {
                        setIsCallback(true)
                    }
                })

                interval = setInterval(() => {
                    try {
                        let durationInMillis = contactObj?.getStatusDuration()
                        let utilizedTime: any = localStorage.getItem("misscallTimer");
                        let misscalTimer = parseInt(utilizedTime) * 1000;
                        if ((agentObj.getState().name === 'MissedCallAgent' || agentObj.getState().name === 'FailedConnectAgent' || isCallback) && misscalTimer !== 0 && durationInMillis > misscalTimer) {
                            onClearCall()
                        }
                        let hms = millisecondsToHMS(durationInMillis);
                        setMinutes(parseInt(hms.split(':')[1]));
                        if(minutes >= 5 && alertShowed === false && contactObj?.getState().type === connect.ContactStateType.CONNECTED){
                            setAlertShowed(true)
                        }
                        setStateDuration(hms)
                    } catch (err) {
                        console.log(err)
                        clearInterval(interval)
                    }
                }, 1000);
            } catch (error) {
                clearInterval(interval)
            }
        } else {
            setCallbackStatus('')
        }

        const getMisscallTimerData = async () => {
            if (agentObj) {
                let routingProfile = agentObj.getRoutingProfile().name;
                let data = await getMisscalltimer(routingProfile)
                if (data?.statusCode === 200) {
                    let timer = data?.body?.Item?.timer || 0;
                    localStorage.setItem("misscallTimer", timer)
                } else {
                    localStorage.setItem("misscallTimer", '0')
                }
            }
        }
        getMisscallTimerData()
        return () => {
            clearInterval(interval)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agentObj, contactObj,alertShowed])

    const onClearCall = () => {
        dispatch(agentSliceAction.setIsAgentMute(false))
        contactObj.clear({
            success: function () {
                setIsCallback(false)
                setAlertShowed(false)
                console.log("ConnectionComponent::onClear::Call Clear Succesfully.");
            },
            failuer: function (err: any) {
                console.log("ConnectionComponent::onClear::Error in Call Clear." + err);
            }
        })
    }

    const redirectToCalls = () => {
        navigate("/calls")
    }
    const notification = () => {
        new Notification("Hi there!");
    }
   
    return (
        
        <React.Fragment>
            
            {!alertShowed && (
                <MissedCallPopup />
            )}

            {(agentCurrentState === 'PendingBusy' || agentCurrentState === 'Pending') &&
                <div className="ongoing-call bg-orange">
                    <div className="call-number">
                        <p onClick={() => { redirectToCalls() }} className="text-white m-0 fw-bold">Incoming call <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                </div>
            }
            {(agentCurrentState === 'Busy') &&
                <div>


                            <div className="ongoing-call bg-primary">
                                <div className="call-number">
                                    <p onClick={() => { redirectToCalls() }} className="text-white m-0 fw-bold">Ongoing call
                                       
                                        <span className="ongoing-time ms-5">{stateDuration}</span>
                                        
                                    </p>

                                </div>

                            </div>

                </div>

            }
    
            {(accountName !== undefined && (contactAttributes !== undefined && contactAttributes.initialConnection === "inbound") && agentCurrentState === 'Busy' && minutes >= 25 && accountName.toLowerCase() !== 'engie') &&
                <div>
                    <div className="time-alert">
                        <div className="call-number">
                            <p onClick={() => { redirectToCalls() }} className="text-white m-0 fw-bold">

                                <img className="clock-alert" src={clockAlarm} alt="clock alarm icon" /> <>LONG CALL TIME ALERT</>

                            </p>
                        </div>

                    </div>

                </div>
                
            }

            {(accountName !== undefined && (contactAttributes !== undefined && contactAttributes.initialConnection === "inbound") && agentCurrentState === 'Busy' && (minutes >= 8 || minutes >= 15) && accountName.toLowerCase() === 'engie') &&
                <div>
                    <div className="time-alert">
                        <div className="call-number">
                            <p onClick={() => { redirectToCalls() }} className="text-white m-0 fw-bold"> 

                                <img className="clock-alert" src={clockAlarm} alt="clock alarm icon" /> <>LONG CALL TIME ALERT</>

                            </p>
                        </div>

                    </div>

                </div>
            } 

            {(agentCurrentState === 'AfterCallWork' || isACW) &&
                <div className="ongoing-call bg-darkgray">
                    <div className="call-number">
                        <p className="text-white m-0 fw-bold">After call work <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                    <div className="ms-2">
                        <button onClick={() => onClearCall()} className="clear-btn">Clear contact</button>
                    </div>
                </div>
            }
            {(agentCurrentState === 'FailedConnectAgent') &&
                <div className="ongoing-call bg-danger">
                    <div className="call-number">
                        <p className="text-white m-0 fw-bold">Call rejected <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                    <div className="ms-2">
                        <button onClick={() => onClearCall()} className="clear-btn">Clear contact</button>
                    </div>
                </div>
            }
            {(agentCurrentState === 'MissedCallAgent' || agentCurrentState === 'AgentHungUp') &&
                <div className="ongoing-call bg-danger">
                    <div className="call-number">
                        <p className="text-white m-0 fw-bold">Missed call <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                    <div className="ms-2">
                        <button onClick={() => onClearCall()} className="clear-btn">Clear contact</button>
                    </div>
                </div>
            }

            {(agentCurrentState === 'FailedConnectCustomer') &&
                <div className="ongoing-call bg-danger">
                    <div className="call-number">
                        <p className="text-white m-0 fw-bold">Customer end call <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                </div>
            }
            {(agentCurrentState === 'CallingCustomer' || monitoringCallStatus === 'connecting') &&
                <div className="ongoing-call bg-success">
                    <div className="call-number">
                        <p onClick={() => { redirectToCalls() }} className="text-white m-0 fw-bold">Call connecting <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                </div>
            }
            {(monitoringCallStatus === 'connected') &&
                <div className="ongoing-call bg-primary">
                    <div className="call-number">
                        <p onClick={() => { redirectToCalls() }} className="text-white m-0 fw-bold">Monitoring call <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                </div>
            }
            {(isCallback && callbackStatus === 'error') &&
                <div className="ongoing-call bg-danger">
                    <div className="call-number">
                        <p className="text-white m-0 fw-bold">Call rejected<span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                    <div className="ms-2">
                        <button onClick={() => onClearCall()} className="clear-btn">Clear contact</button>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}
export default CallStatus